<template>
  <div class="identify-page">
    <v-sheet class="folded-corner identify-panel">
      <v-container>
        <v-card elevation="0" class="align-center pa-4 mx-auto">
          <div class="identify-header">
            <h1>{{ $t("message.PleaseSelect") }}</h1>
            <v-divider class="header-line"></v-divider>
          </div>

          <div class="document-grid">
            <button class="document-option" type="button" @click="GotoPassport()">
              <img src="@/assets/passport.png" alt="Passport" />
              <span>{{ $t("message.Passport") }}</span>
            </button>
            <button class="document-option" type="button" @click="GotoNationalIDCard()">
              <img src="@/assets/id-card.png" alt="ID card" />
              <span>{{ $t("message.IDcard") }}</span>
            </button>
          </div>

          <div class="identify-actions">
            <v-btn color="#344054" class="box white--text text-capitalize" router @click="BackToPDPAPage()">
              {{ $t("message.Back") }}
            </v-btn>
          </div>
        </v-card>
      </v-container>
    </v-sheet>

    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear indeterminate color="#ffffff" class="mb-0"></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import axios from "axios";
import enurl from "@/api/environment";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "IdentifySelection",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
    };
  },
  mounted: function () {
    setInterval(() => {
      this.getCurrentDate();
    }, 1000);
  },

  methods: {
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    BackToPDPAPage() {
      let self = this;
      self.$router.push("/PDPAPage");
    },

    GotoNationalIDCard() {
      let self = this;
      self.$router.push("/NationalIDCard");
    },

    GotoPassport() {
      let self = this;
      self.$router.push("/NationalPassport");
    },
  },
};
</script>
<style scoped>
.identify-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(28px, 5vw, 72px);
}

.identify-panel {
  min-height: 0 !important;
}

.identify-header {
  text-align: center;
  margin-bottom: clamp(22px, 4vh, 44px);
}

.identify-header h1 {
  color: #344054;
  font-size: clamp(42px, 4.2vw, 72px);
  font-weight: 800;
  line-height: 1.1;
  margin: 0;
}

.header-line {
  width: min(360px, 36vw);
  margin: 18px auto 0;
  border-top-width: 8px !important;
  border-color: #344054 !important;
}

.document-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: clamp(22px, 3vw, 40px);
}

.document-option {
  min-height: clamp(270px, 38vh, 380px);
  border: 2px solid rgba(52, 64, 84, 0.2);
  background: linear-gradient(180deg, #ffffff 0%, #f4fbfd 100%);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease;
}

.document-option:hover {
  transform: translateY(-3px);
  border-color: #344054;
  box-shadow: 0 18px 38px rgba(16, 24, 40, 0.12);
}

.document-option img {
  width: clamp(170px, 15vw, 260px);
  height: auto;
}

.document-option span {
  color: #344054;
  font-size: clamp(32px, 3vw, 50px);
  font-weight: 800;
}

.identify-actions {
  display: flex;
  justify-content: center;
  margin-top: clamp(22px, 4vh, 40px);
}

.identify-actions .box {
  font-size: clamp(30px, 2.8vw, 45px) !important;
  height: 92px !important;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }

  .document-grid {
    grid-template-columns: 1fr;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
